import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Badge,
  Button,
  Card,
  Col,
  Form,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import { Heading, Rating } from "@lomarengas/design-system";
import {
  AccommodationDetailsBasic,
  AccommodationImage,
} from "./accommodationSlice";
import React from "react";

const AccommodationImages2 = ({
  accommodationImages,
}: {
  accommodationImages: AccommodationImage[];
}) => {
  const [selectedImageUrl, setSelectedImageUrl] = useState<string | null>(null);
  const renderAccommodationImage = (accommodationImage: AccommodationImage) => {
    //console.log(accommodationImage);
    return (
      <li className="col">
        <a
          href="#"
          role="button"
          className="card"
          onClick={() => setSelectedImageUrl(accommodationImage.carouselUrl)}
        >
          <span className="ratio ratio-3x2 card-img-top img-hover">
            <img
              alt=""
              className="object-fit-cover"
              src={accommodationImage.carouselUrl}
            />
          </span>
          <span className="card-body smaller p-8">
            <span className="d-block text-truncate">
              {accommodationImage.index}. {accommodationImage.fileName}
            </span>
          </span>
        </a>
      </li>
    );
  };
  const renderAccommodationImages = (
    accommodationImages: AccommodationImage[],
  ) => {
    return (
      <>
        {accommodationImages != null &&
          accommodationImages.map((image: AccommodationImage) => {
            {
              return renderAccommodationImage(image);
            }
          })}
      </>
    );
  };
  return (
    <>
      <ul className="list-unstyled row row-cols-2 row-cols-sm-4 row-cols-xl-6 g-16">
        {renderAccommodationImages(accommodationImages)}
      </ul>

      <div className="px-24 p-xl-48 border-top border-2 mt-40">
        <Row className="g-xl-40">
          <Col md={6} xl={7} className="d-flex align-items-center">
            <div className="px-xl-48 lh-lg">
              <Heading
                Level={5}
                TextPosition="left-top"
                Title="Kuvapalvelu"
              ></Heading>
              <h3>Näin teemme mökkisi kuvista houkuttelevammat</h3>
              <p className="mt-lg-32">
                Hyvä kuva kertoo enemmän kuin tuhat sanaa – ja mökkisi ansaitsee
                tulla nähdyksi parhaassa mahdollisessa valossa. Me Lomarenkaalla
                huolehdimme siitä, että mökkisi kuvat ovat myyntikunnossa ja
                herättävät kiinnostuksen jo ensi vilkaisulla. Näin sen teemme!
              </p>
            </div>
          </Col>
          <Col md={6} xl={5}>
            <img
              alt=""
              className="w-100 px-xl-40 mt-40 p-16"
              src="/image-service.png"
            />
          </Col>
        </Row>

        <Row className="g-lg-48 text-center row-cols-1 row-cols-lg-3 mt-16 mx-xl-16">
          <Col>
            <span className="d-inline-block mb-24 fs-2 bg-light text-primary rounded-circle p-24 lh-1">
              <span className="bi bi-sliders"></span>
            </span>

            <h6 className="text-center">Värien ja kirkkauden säätäminen</h6>
            <p className="small">
              Kirkastamme kuviesi värit ja valaistuksen, jotta mökkisi pääsee
              oikeuksiinsa – aivan kuin olisit itse paikan päällä. Poistamme
              kuvista turhat häiriötekijät, jotta asiakkaan huomio kiinnittyy
              mökkisi ainutlaatuisiin yksityiskohtiin. Emme vain parantele:
              mökkisi takka voi kuvassa loistaa lämpimänä, vaikka se
              kuvaushetkellä olisikin kylmillään.
            </p>
          </Col>
          <Col>
            <span className="d-inline-block mb-24 fs-2 bg-light text-primary rounded-circle p-24 lh-1">
              <span className="bi bi-magic"></span>
            </span>

            <h6 className="text-center">Ammattitaitoinen valokuvaus </h6>
            <p className="small">
              Mökkiasiantuntijamme tulevat paikan päälle kuvaamaan kohteesi
              ammattitason välineillä. Henkilökuntamme käy säännöllisesti
              valokuvauskoulutuksia, jotta kuvat ovat visuaalisesti
              houkuttelevia ja kohottavat mökkisi arvoa. Tarvittaessa
              uusintakuvaamme kohteen.
            </p>
          </Col>
          <Col>
            <span className="d-inline-block mb-24 fs-2 bg-light text-primary rounded-circle p-24 lh-1">
              <span className="bi bi-bounding-box"></span>
            </span>

            <h6 className="text-center">Kuvien optimointi verkkoa varten</h6>
            <p className="small">
              Optimoimme mökkikuvat niin, että ne latautuvat nopeasti ja
              näyttävät upeilta kaikilla laitteilla, mobiilista tietokoneisiin.
              Kuvien koko ja laatu mukautuvat automaattisesti eri
              jakelukanaviin, joten sinun ei tarvitse huolehtia teknisistä
              yksityiskohdista.
            </p>
          </Col>
        </Row>
      </div>
      {selectedImageUrl && (
        <div
          onClick={() => setSelectedImageUrl(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            cursor: "zoom-out",
          }}
        >
          <img
            src={selectedImageUrl}
            alt=""
            style={{ maxHeight: "90%", maxWidth: "90%" }}
          />
        </div>
      )}
    </>
  );
};

export default AccommodationImages2;
export { AccommodationImages2 };
